import { NavLink } from "react-router-dom";
import { FaBars, FaFileImport, FaHome, FaUserAlt } from "react-icons/fa";
import { MdAddBox, MdAddCircleOutline, MdInfo, MdOutlineSecurity, MdPerson, MdPersonOutline, MdPrivacyTip } from "react-icons/md";
import { FaPhoneSquareAlt } from "react-icons/fa";
import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Navbar from "../../Navbar/Navbar";
import Ctlogo  from '../../../assets/img/logo-ct-dark.png';
import profilePic from '../../../Images/DreamTown.png'; 
import AuthService from "../../../modules/Admin/services/AuthService";

const routes = [
    { 
      path: "/dashboard",
      name: "Dashboard",
      icon: <FaHome />,
    },
    {
        path: "/client",
        name: "Clients",
        icon: <MdPersonOutline />,
      },
    
  //  {
  //     path: "/registeruser",
  //     name: "Employees",
  //     icon: <MdPerson />,
  //   },

    {
      path: "/integrationsettings",
      name: "Integration",
      icon: <FaFileImport />,
    },

    // {
    //   path: "/leads",
    //   name: "Leads",
    //   icon: <MdAddCircleOutline />,
    // }, 

    // {
    //   path: "/leadassigned",
    //   name: "Assigned Leads",
    //   icon: <MdAddBox />,
    // }, 

    // {
    //   path: "/pendingfollowups",
    //   name: "Pending FollowUps",
    //   icon: <FaUserAlt />,
    // },
    
    {
      path: "/quicksupport",
      name: "Quick Support",
      icon: <FaPhoneSquareAlt  />,
    },
    // {
    //   path: "/about",
    //   name: "About",
    //   icon: <MdInfo />,
    // },
    // {
    //   path: "/privacy",
    //   name: "Privacy",
    //   icon: <MdPrivacyTip />,
    // },
    // {
    //   path: "/termsandconditions",
    //   name: "Terms and Conditions",
    //   icon: <MdOutlineSecurity />,
    // },
   
  ];

  const SideBar = ({ children }) => {
    const [isOpen, setIsOpen] = useState(true);
    const toggle = () => setIsOpen(!isOpen);
    const inputAnimation = {
      hidden: {
        width: 0,
        padding: 0,
        transition: {
          duration: 0.2,
        },
      },
      show: {
        width: "140px",
        padding: "5px 15px",
        transition: {
          duration: 0.2,
        },
      },
    };
  
    const showAnimation = {
      hidden: {
        width: 0,
        opacity: 0,
        transition: {
          duration: 0.5,
        },
      },
      show: {
        opacity: 1,
        width: "auto",
        transition: {
          duration: 0.5,
        },
      },
    };

    // const [agency, setAgency] = useState('');
    const [loading, setLoading] = useState(true);
     const ClientId = AuthService.getLoggedInClientId();
   
    //  useEffect(() => {
    //    async function getAgencyLogoByClientId()  {
    //       try {
    //         const response = await AuthService.getAgencyLogoAndNameByClientId(ClientId);
    //         setAgency(response);
    //         console.log(response);
    //         setLoading(false);
    //       } catch (error) {
    //         console.error('Error fetching notifications:', error);
    //         setLoading(false);
    //       }
    //     };
    //     getAgencyLogoByClientId();
    //   }, [ClientId]);
   
  
  
    return (
      <>
    <aside className="sidenav navbar navbar-vertical navbar-expand-xs border-radius-lg fixed-start ms-2 bg-white my-2" id="sidenav-main">
      <div className="sidenav-header">
        <i className="fas fa-times p-3 cursor-pointer text-dark opacity-5 position-absolute end-0 top-0 d-none d-xl-none" aria-hidden="true" id="iconSidenav"></i>
        <a className="navbar-brand px-4 py-3 m-0" href="https://amritweb.in" target="_blank">
        <img src={`https://amritweb.in/wp-content/uploads/2023/06/WhatsApp-Image-2023-06-27-at-3.21.56-PM.jpeg`} className="navbar-brand-img" width="90" height="60" alt="main_logo"/>
          <span className="ms-1 text-sm text-dark"></span>
        </a>
      </div>
      <hr className="horizontal dark mt-0 mb-2"/>
      <div className="collapse navbar-collapse w-auto" id="sidenav-collapse-main">
        <section className="routes">
          <ul className="navbar-nav">
            {routes.map((route, index) => (
              <li className="nav-item" key={index}>
                <NavLink
                  to={route.path}
                  className="nav-link text-dark d-flex align-items-center"
                  activeClassName="active"
                >
                  <div className="icon me-2">
                    {route.icon}
                  </div>
                  {isOpen && (
                    <div className="link_text">{route.name}</div>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </aside>
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
      <Navbar/>
      <div className="container-fluid py-2">
        {children}
      </div>
    </main>
  </>
  
    );
  
  };



export default SideBar;
